import { create } from "zustand";

/**
 * Which encrypted session's dialog is open, if any.
 *
 * The live-session listener uses it to decide whether an event is worth
 * invalidating that session's expensive per-id queries for (timeline, peak,
 * refined triangulation). Nobody else is looking at them, so nobody else pays
 * for a session that ticks once a second.
 *
 * A store rather than props or context on purpose: the listener sits at the
 * app root and reads this imperatively inside an event handler. Threading it
 * through React state would put it in the listener's effect deps, and opening
 * a dialog would then tear down and reopen the EventSource.
 */
interface ActiveEncryptedDialogState {
  id: number | null;
  setId: (id: number | null) => void;
}

export const useActiveEncryptedDialogStore = create<ActiveEncryptedDialogState>(
  (set) => ({
    id: null,
    setId: (id) => set({ id }),
  }),
);
